import { Text, Toast } from 'iq-blueberry'

import NewDowngradeExperienceModal from 'components/common/DowngradeExperienceModal'
import SendingFormModal from 'components/common/SendingFormModal'
import SimpleModal from '../SimpleModal'

import { useFRModal, useEmailModal, usePhoneModal } from './hook'

export const FormAlerts = ({
  partnerConfig,
  sendProposalModalName,
  closeSendFormModal,
  openedModals,
  handleAcceptSuggestion,
  handleSkipChangeProductSuggestion,
  suggestionModalOpen,
  downgradeData,
}) => {
  const { isFRModalOpen, closeFRModal } = useFRModal()

  const { isEmailModalOpen, closeEmailModal } = useEmailModal()

  const { isPhoneModalOpen, closePhoneModal } = usePhoneModal()

  const choosenCard = partnerConfig?.tracking?.brand

  return (
    <>
      <SendingFormModal
        partnerName={partnerConfig?.partnerName}
        partnerLogo={partnerConfig?.partnerLogo}
        openedModals={openedModals}
        modalName={sendProposalModalName}
        onCloseModal={closeSendFormModal}
      />
      <NewDowngradeExperienceModal
        isDrawerOpen={suggestionModalOpen}
        downgradeData={downgradeData}
        handleSkipDowngrade={handleSkipChangeProductSuggestion}
        handleAcceptDowngrade={handleAcceptSuggestion}
        currentProduct={{
          cardSlug: "cards-bancodobrasil-ourocardfacil",
          partner: 'bb',
          title: 'Ourocard Fácil',
        }}
        workflowId={choosenCard}
        withTracking
        origin="bb"
      />

      <SimpleModal
        isOpen={isFRModalOpen}
        actionButton={closeFRModal}
        onCloseModal={closeFRModal}
        title="Dados diferentes da base da Receita Federal"
        textButton="Tentar novamente"
        customClass="bb-simple-modal--revenue">
        <Text as="p" variant="body-medium" className="app-modal__text">
          Importante garantir que não há nenhum erro de digitação ou abreviações
          nos seguintes campos:
        </Text>
        <ul className="app-modal__list">
          <li className="app-modal__list-item">
            <Text as="p" variant="body-medium" className="app-modal__text">
              Nome Completo
            </Text>
          </li>
          <li className="app-modal__list-item">
            <Text as="p" variant="body-medium" className="app-modal__text">
              Data de Nascimento
            </Text>
          </li>
          <li className="app-modal__list-item">
            <Text as="p" variant="body-medium" className="app-modal__text">
              Nome da Mãe
            </Text>
          </li>
        </ul>
        <Text as="p" variant="body-medium" className="app-modal__text">
          Caso não encontre nada errado, tente alterar os campos “Nome Completo”
          e “Nome da Mãe”, utilizando o nome de solteiro da pessoa.
        </Text>
      </SimpleModal>
      <Toast
        text="Não é possível seguir com esse email. Altere a informação e tente novamente."
        type="error"
        isVisible={isEmailModalOpen}
        close={closeEmailModal}
      />
      <Toast
        text="Não é possível seguir com esse celular. Altere a informação e tente novamente."
        type="error"
        isVisible={isPhoneModalOpen}
        close={closePhoneModal}
      />
    </>
  )
}
